module.exports = __webpack_public_path__ + "static/media/contributions.4bf5e76c.png";